import { useMemo } from "react";
import DOMPurify from "dompurify";

// external links naye tab me kholo
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && /^https?:/i.test(node.getAttribute("href") || "")) {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export function BlogContent({ html }) {
  const clean = useMemo(() => DOMPurify.sanitize(html || ""), [html]);

  return (
    <>
      <div className="blog-content mt-8" dangerouslySetInnerHTML={{ __html: clean }} />
      <style>{`
        .blog-content { font-size: 1.05rem; line-height: 1.8; color: #1e293b; word-break: break-word; }
        .blog-content h1 { font-size: 1.8rem; font-weight: 800; margin: 2rem 0 0.75rem; line-height: 1.25; }
        .blog-content h2 { font-size: 1.5rem; font-weight: 700; margin: 2rem 0 0.75rem; line-height: 1.3; }
        .blog-content h3 { font-size: 1.25rem; font-weight: 700; margin: 1.6rem 0 0.6rem; }
        .blog-content h4 { font-size: 1.1rem; font-weight: 700; margin: 1.4rem 0 0.5rem; }
        .blog-content p { margin: 1rem 0; }
        .blog-content ul { list-style: disc; padding-left: 1.6rem; margin: 1rem 0; }
        .blog-content ol { list-style: decimal; padding-left: 1.6rem; margin: 1rem 0; }
        .blog-content li { margin: 0.35rem 0; }
        .blog-content b, .blog-content strong { font-weight: 700; }
        .blog-content i, .blog-content em { font-style: italic; }
        .blog-content u { text-decoration: underline; }
        .blog-content strike, .blog-content s { text-decoration: line-through; }
        .blog-content blockquote {
          border-left: 4px solid #F5A623; padding: 0.5rem 1.1rem; margin: 1.4rem 0;
          color: #475569; background: #f8fafc; border-radius: 0 0.5rem 0.5rem 0;
        }
        .blog-content pre {
          background: #0f172a; color: #e2e8f0; padding: 1rem 1.1rem; border-radius: 0.6rem;
          overflow-x: auto; font-family: ui-monospace, monospace; font-size: 0.85rem; margin: 1.4rem 0;
        }
        .blog-content code { font-family: ui-monospace, monospace; background: #f1f5f9; padding: 0.1rem 0.35rem; border-radius: 0.25rem; font-size: 0.9em; }
        .blog-content pre code { background: transparent; padding: 0; }
        .blog-content a { color: #d97706; text-decoration: underline; }
        .blog-content a:hover { color: #b45309; }
        .blog-content img { max-width: 100%; height: auto; border-radius: 0.75rem; margin: 1.4rem auto; display: block; }
        .blog-content table { border-collapse: collapse; width: 100%; margin: 1.4rem 0; display: block; overflow-x: auto; }
        .blog-content th, .blog-content td { border: 1px solid #cbd5e1; padding: 0.5rem 0.75rem; text-align: left; }
        .blog-content th { background: #f1f5f9; font-weight: 700; }
        .blog-content hr { border: 0; border-top: 1px solid #e2e8f0; margin: 2rem 0; }
        .blog-content > :first-child { margin-top: 0; }
      `}</style>
    </>
  );
}